import React from 'react'

const TermsAndPrivacy = () => {
    return (
<div style={{justifyContent:'center', alignItems:'center', padding:20}}>
  <h2 style={{marginTop:120}}>
    <strong style={{fontSize:'17px'}}>KULLANIM VE GİZLİLİK SÖZLEŞMESİ</strong>
  </h2>
  <p>
    <strong style={{fontSize:'17px'}}>&nbsp;</strong>
  </p>
  <ol>
    <li>
      <strong style={{fontSize:'17px'}}> Taraflar</strong>
    </li>
  </ol>
  <p>
    Bu Kullanım Sözleşmesi ("Sözleşme"), BİYOMED KARİYER İKAL MÜHENDİSLERİ
    DERNEĞİ&nbsp; &nbsp;("Biyomed&nbsp; Kariyer ") ile Biyomed Kariyer ’e üye
    olan veya Biyomed Kariyer ’i kullanan tüm gerçek ve tüzel kişiler
    ("Kullanıcı") arasında akdedilmiştir.
  </p>
  <ol start={2}>
    <li>
      <strong style={{fontSize:'17px'}}> Tanımlar</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Biyomed Kariyer :</strong> Biyomed Kariyer tarafından takip edilen
      , kariyer, iş ilanları, özgeçmiş yönetimi ve ilgili hizmetlerin sunulduğu
      web sitesi ve/veya mobil uygulamalardır.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Kullanıcı: </strong>Biyomed Kariyer aşağıdaki kullanıcı
      kategorilerini içerir:
    </li>
  </ul>
  <ol>
    <li>a) İş Arayanlar:</li>
  </ol>
  <p>
    &nbsp;Kariyer profili oluşturabilir. İş ilanlarına başvurabilir. Özgeçmiş
    yükleyebilir.&nbsp;
  </p>
  <ol>
    <li>b) İşverenler:</li>
  </ol>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;İş ilanı yayınlayabilir. Aday
    profillerini görüntüleyebilir. Başvuru süreçlerini yönetebilir.
  </p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Hizmetler:</strong> Biyomed Kariyer tarafından kullanıcılara
      sunulan iş arama, ilan yayınlama, profil oluşturma, iletişim ve diğer
      ilgili hizmetlerdir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>İçerik:</strong> Kullanıcılar tarafından Biyomed Kariyer’e
      yüklenen metin, görsel, video, doküman ve diğer materyallerdir.
    </li>
  </ul>
  <ol start={3}>
    <li>
      <strong style={{fontSize:'17px'}}> Kullanım Sözleşmesinin Kapsamı ve Etik Kurallar</strong>
    </li>
  </ol>
  <ul>
    <li>
      İşbu Sözleşme, Biyomed Kariyer tarafından Kullanıcılara sunulan tüm
      hizmetlerin kullanım koşullarını, hak ve yükümlülükleri belirler.
    </li>
    <li>
      Biyomed Kariyer’e erişim sağlayan tüm kullanıcılar, bu Sözleşme
      hükümlerini kabul etmiş sayılırlar.
    </li>
  </ul>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Genel Kullanım İlkeleri</strong>
    </li>
  </ul>
  <p>
    &nbsp;Kullanıcılar Biyomed Kariyer 'i yalnızca yasal ve etik amaçlarla
    kullanmayı kabul eder. Biyomed Kariyer üzerinden elde edilen tüm bilgiler
    yalnızca kişisel kariyer amaçları için kullanılabilir.
  </p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Bilgi Paylaşımı Kısıtlamaları</strong>
    </li>
  </ul>
  <p>
    Biyomed Kariyer den elde edilen kullanıcı bilgileri, iş başvurusu ve kariyer
    yönetimi dışında herhangi bir amaçla kullanılamaz. Kullanıcı bilgileri 3.
    şahıslarla paylaşılamaz, satılamaz veya ticari amaçlarla kullanılamaz.
  </p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Kullanıcı (İşveren) Yükümlülükleri</strong>
    </li>
  </ul>
  <p>
    İş ilanları yalnızca gerçek ve mevcut iş pozisyonları için açılabilir.
    Sahte, yanıltıcı veya dolandırıcılık amaçlı iş ilanları kesinlikle yasaktır.
    İşverenler, ilanda belirtilen pozisyon ve çalışma koşullarının gerçeği
    yansıtmasından sorumludur.
  </p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Kullanıcı ( İş arayan )Yükümlülükleri</strong>
    </li>
  </ul>
  <p>
    &nbsp;Kullanıcılar yalnızca gerçek ve mevcut niteliklerine uygun
    pozisyonlara başvurabilir. Yanıltıcı, eksik veya yanlış bilgi içeren
    başvurular yapmayacağını kabul edecektir. Aynı pozisyona gereksiz ve art
    arda çoklu başvurular yapılamaz.
  </p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Etik Dışı Kullanım ve Yaptırımlar</strong>
    </li>
  </ul>
  <p>
    Biyomed Kariyer , etik dışı kullanım tespit edildiğinde aşağıdaki
    yaptırımları uygulama hakkına sahiptir:
  </p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    &nbsp;* Kullanıcı hesabını geçici olarak askıya alma.
  </p>
  <p>&nbsp;* Kullanıcı hesabını kalıcı olarak kapatma.</p>
  <p>&nbsp;* Yasal mercilere başvurma.</p>
  <p>&nbsp;</p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Başvuru ve İlan Etik Kuralları</strong>
    </li>
  </ul>
  <p>
    Kullanıcılar, Biyomed Kariyer 'in itibarını zedeleyecek her türlü eylemden
    kaçınmayı taahhüt eder. Başvurular ve ilanlar:
  </p>
  <p>&nbsp; * Gerçeği yansıtmalıdır.</p>
  <p>
    &nbsp; * Başka&nbsp; kişi , kurum veya&nbsp; diğer üçüncü şahısların adına
    başvuru yada ilan açılmamalıdır.
  </p>
  <p>&nbsp; * Yasal düzenlemelere uygun olmalıdır.</p>
  <p>&nbsp; * Etik kurallara riayet etmelidir.</p>
  <p>
    <strong style={{fontSize:'17px'}}>&nbsp;</strong>
  </p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Veri Kullanımı Sınırlandırması</strong>
    </li>
  </ul>
  <p>
    Biyomed Kariyer, üzerindeki tüm veriler münhasıran kariyer ve istihdam
    amaçlı kullanılabilir. Ticari, reklam veya başka amaçlarla veri toplanması
    ve kullanılması kesinlikle yasaktır.
  </p>
  <p>&nbsp;</p>
  <ol start={4}>
    <li>
      <strong style={{fontSize:'17px'}}> Üyelik ve Hesap Yönetimi</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Kayıt:</strong> Biyomed Kariyer’e üye olmak isteyen kullanıcılar,
      doğru, eksiksiz ve güncel bilgileri sağlayarak kayıt işlemlerini
      gerçekleştirmelidir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Hesap Güvenliği:</strong> Kullanıcı, kendisine ait kullanıcı adı,
      şifre ve diğer hesap bilgilerini gizli tutmakla, üçüncü şahısların
      erişimine karşı gerekli önlemleri almakla yükümlüdür.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Hesap Sorumluluğu:</strong> Hesap üzerinden gerçekleştirilen tüm
      işlemler tamamen Kullanıcı’ya aittir. Hesap bilgilerini paylaşması veya
      başkalarının kullanımına açması durumunda ortaya çıkabilecek zararlardan
      Biyomed Kariyer sorumlu tutulamaz.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Hesabın İptali:</strong> Kullanıcının Sözleşme hükümlerine aykırı
      davranışları tespit edildiğinde, Biyomed Kariyer üyenin hesabını askıya
      alma veya kalıcı olarak kapatma hakkını saklı tutar.
    </li>
  </ul>
  <ol start={5}>
    <li>
      <strong style={{fontSize:'17px'}}> Hizmetlerin Kullanımı</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Kullanım Şartları</strong> : Kullanıcı, Biyomed Kariyer’i yalnızca
      yasal amaçlarla kullanmayı, üçüncü şahısların haklarını ihlal etmeyecek
      şekilde hareket etmeyi kabul eder. Üçüncü şahısların haklarını ihlal
      etmeyecek. Biyomed Kariyer 'in itibarını zedeleyecek eylemlerden
      kaçınacaktır. Kullanıcılar Biyomed Kariyer 'i kullanırken aşağıdaki
      eylemlerde bulunamazlar:
    </li>
  </ul>
  <p>- Yanıltıcı, sahte veya yalan bilgi paylaşmak,</p>
  <p>
    - Başka kişi , kurum veya diğer üçüncü şahısların adına başvuru yada ilan
    açmak,
  </p>
  <p>- Başka kullanıcıların kişisel bilgilerini izinsiz toplamak,</p>
  <p>
    - Biyomed Kariyer 'in işleyişini engelleyecek teknik müdahalelerde bulunmak,
  </p>
  <p>- Telif hakkı ihlali içeren içerikler paylaşmak,</p>
  <p>- Hakaret, tehdit veya taciz içeren içerikler üretmek,</p>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>İçerik Yükleme ve Yayınlama:</strong> Kullanıcılar, Biyomed
      Kariyer’e yükledikleri içeriklerin doğru, eksiksiz ve hukuka uygun
      olduğunu; telif, marka, özel hayatın gizliliği ve diğer yasal hakları
      ihlal etmediğini beyan ederler.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Denetim Hakkı:</strong> Biyomed Kariyer , yayınlanan içerikleri
      Sözleşme hükümlerine aykırılık açısından kontrol etme, düzenleme veya
      yayından kaldırma hakkını saklı tutar.
    </li>
  </ul>
  <ol start={6}>
    <li>
      <strong style={{fontSize:'17px'}}> Fikri Mülkiyet Hakları</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Biyomed Kariyer &nbsp;İçeriği:</strong> Biyomed Kariyer de yer
      alan tüm metinler, grafikler, logolar, yazılımlar, resimler ve diğer
      materyaller, Biyomed Kariyer &nbsp;veya ilgili üçüncü taraflara ait olup,
      telif ve diğer fikri mülkiyet haklarıyla korunmaktadır.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Lisans:</strong> Kullanıcıya, Biyomed Kariyer’deki içerikleri
      yalnızca kişisel ve ticari olmayan amaçlarla görüntüleme ve kullanma hakkı
      tanınır. İçeriklerin izinsiz kopyalanması, dağıtılması veya değiştirilmesi
      yasaktır.
    </li>
  </ul>
  <ol start={7}>
    <li>
      <strong style={{fontSize:'17px'}}> Gizlilik ve Kişisel Verilerin Korunması</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Veri İşleme:</strong> Biyomed Kariyer , kullanıcıların kişisel
      verilerini, yürürlükteki veri koruma mevzuatı ve Gizlilik Politikası
      çerçevesinde işlemektedir. KVKK metnine{" "}
      <a style={{color:'blue'}} href="https://www.biyomed.org.tr/kvkk-metni">
        Siteye git
      </a>{" "}
      linkinden&nbsp; ulaşabilirsiniz.&nbsp;
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Gizlilik Politikası:</strong> Kullanıcı, Biyomed Kariyer’e
      kaydolarak ve hizmetleri kullanarak Gizlilik Politikasını da kabul etmiş
      sayılır.
    </li>
  </ul>
  <ol start={8}>
    <li>
      <strong style={{fontSize:'17px'}}> Sorumluluk Reddi ve Garantiler</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Hizmetlerin Sürekliliği:</strong> Biyomed Kariyer , hizmetlerin
      kesintisiz, hatasız veya sürekli olacağını garanti etmez. Teknik arızalar,
      bakım çalışmaları veya kontrol dışı nedenlerden dolayı hizmet kesintileri
      yaşanabilir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>İçeriklerin Doğruluğu:</strong> Kullanıcılar tarafından
      oluşturulan içeriklerin doğruluğu ve güvenilirliği konusunda Biyomed
      Kariyer herhangi bir garanti vermez; içeriklerin kullanımı tamamen
      Kullanıcı sorumluluğundadır.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Üçüncü Taraf Bağlantılar:</strong> Biyomed Kariyer , üçüncü taraf
      web sitelerine veya kaynaklara bağlantılar içerebilir. Bu bağlantıların
      içeriklerinden veya güvenliğinden Biyomed Kariyer sorumlu değildir.
    </li>
  </ul>
  <ol start={9}>
    <li>
      <strong style={{fontSize:'17px'}}>
        {" "}
        Hizmetlerin Değiştirilmesi, Askıya Alınması veya Sonlandırılması
      </strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Değişiklik Hakkı:</strong> Biyomed Kariyer , sunduğu hizmetlerin
      kapsamını, özelliklerini ve erişilebilirliğini değiştirme hakkını saklı
      tutar. Hizmetlerde yapılacak değişiklikler önceden Biyomed Kariyer
      üzerinden duyurulacaktır.
    </li>
  </ul>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Askıya Alma/Sonuçlandırma:</strong> Kullanıcının Sözleşme
      hükümlerine aykırı hareket etmesi durumunda, Biyomed Kariyer hizmetleri
      geçici olarak askıya alma veya kalıcı olarak sonlandırma hakkını
      kullanabilir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Üyelik Sildirme:</strong> Kullanıcılar iletişim sayfasından nedeni
      ile birlikte &nbsp;mail atarak üyelik sildirme taleplerini iletere
      üyeliklerini sildirebilir.
    </li>
  </ul>
  <ol start={11}>
    <li>
      <strong style={{fontSize:'17px'}}> Uyuşmazlıkların Çözümü ve Geçerli Hukuk</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Geçerli Hukuk:</strong> İşbu Sözleşme ve hizmetlerin kullanımı,
      Türkiye Cumhuriyeti kanunlarına tabidir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Uyuşmazlık Çözümü:</strong> Sözleşmeden doğabilecek
      uyuşmazlıkların çözümünde Ankara mahkemeleri ve icra daireleri yetkilidir.
      Taraflar, öncelikle müzakere yoluyla anlaşmaya varmayı kabul ederler.
    </li>
  </ul>
  <ol start={12}>
    <li>
      <strong style={{fontSize:'17px'}}> Sözleşme Değişiklikleri</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Değişiklik Hakkı:</strong> Biyomed Kariyer , işbu Sözleşme’nin
      herhangi bir hükmünü tek taraflı olarak değiştirme hakkını saklı tutar.
      Yapılan değişiklikler, Biyomed Kariyer üzerinde yayımlanacak ve
      yayımlandığı andan itibaren geçerli olacaktır.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Kullanıcı Onayı:</strong> Sözleşme’de yapılan değişikliklerden
      sonra Biyomed Kariyer’i kullanmaya devam eden kullanıcılar, yeni hükümleri
      kabul etmiş sayılır.
    </li>
  </ul>
  <ol start={13}>
    <li>
      <strong style={{fontSize:'17px'}}> Bildirimler ve İletişim</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Bildirim Yöntemi:</strong> Taraflar arasında yapılacak resmi
      bildirimler, Biyomed Kariyer’de yayımlanacak duyurular veya kullanıcı
      tarafından kayıtlı iletişim bilgilerinin kullanılması suretiyle
      gerçekleştirilecektir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>İletişim Bilgileri:</strong> Kullanıcılar, Biyomed Kariyer
      &nbsp;ile ilgili her türlü soru, öneri veya şikayetlerini Biyomed Kariyer
      İletişim alanı üzerinden iletebilirler.
    </li>
  </ul>
  <ol start={14}>
    <li>
      <strong style={{fontSize:'17px'}}> Mücbir Sebepler</strong>
    </li>
  </ol>
  <ul>
    <li>
      Tarafların kontrolü dışındaki doğal afetler, savaş, grev, salgın hastalık
      gibi mücbir sebeplerden kaynaklanan aksaklık veya ifa imkânsızlıkları
      durumunda, taraflar sorumluluktan muaf tutulur.
    </li>
  </ul>
  <ol start={15}>
    <li>
      <strong style={{fontSize:'17px'}}> Son Hükümler</strong>
    </li>
  </ol>
  <ul>
    <li>
      <strong style={{fontSize:'17px'}}>Tüm Anlaşmanın Konusu:</strong> İşbu Sözleşme, taraflar arasındaki
      tam ve münhasır anlaşmayı oluşturur.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Geçersiz Hükümler:</strong> Sözleşmenin herhangi bir hükmünün
      geçersiz veya uygulanamaz olması durumunda, diğer hükümler
      etkilenmeyecektir.
    </li>
    <li>
      <strong style={{fontSize:'17px'}}>Yürürlük:</strong> Kullanıcı, Biyomed Kariyer’e erişim sağlayarak
      veya hizmetleri kullanarak işbu Sözleşme’nin tüm hükümlerini okuduğunu,
      anladığını ve kabul ettiğini beyan eder.
    </li>
  </ul>
  <p>&nbsp;</p>
</div>

    );
  };
  
  export default TermsAndPrivacy;
  